'use strict';
import angular from 'angular'
import MODULE_NAME from '../../app'
import ConstantSettings from './constantSettings'
import ParameterNames from './parameters'

angular.module(MODULE_NAME).constant('constantSettings', ConstantSettings)
.constant('parameterNames', ParameterNames);
  


// WEBPACK FOOTER //
// ./src/app/scripts/constants/index.js